module.exports = __webpack_public_path__ + "static/media/cylitaire.4e7731e2.jpg";